export { TransparentRatesSection } from './TransparentRatesSection';
